// extracted by mini-css-extract-plugin
export default {"body":"PatientImportDialog_body__1RaR4"};